import * as React from "react";
export var ComponentServices;
(function (ComponentServices) {
  var missingContextError = new Error("[ComponentServicesContext.Provider] Could not find component service context data. " + "Please use 'ComponentServicesContext.Provider' to initialize it");
  ComponentServices.Context = /*#__PURE__*/React.createContext({
    get navigationService() {
      throw missingContextError;
    },
    get timezoneService() {
      throw missingContextError;
    }
  });
})(ComponentServices || (ComponentServices = {}));